"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedView = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var GroupedView = function GroupedView() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 0H19.2C20.5255 0 21.6 1.07452 21.6 2.4V8.4C21.6 9.72548 20.5255 10.8 19.2 10.8H4.8C3.47452 10.8 2.4 9.72548 2.4 8.4V2.4C2.4 1.07452 3.47452 0 4.8 0ZM19.2 2.40021V8.40021H4.8V2.40021H19.2ZM4.8 13.2001H19.2C20.5255 13.2001 21.6 14.2746 21.6 15.6001V21.6001C21.6 22.9256 20.5255 24.0001 19.2 24.0001H4.8C3.47452 24.0001 2.4 22.9256 2.4 21.6001V15.6001C2.4 14.2746 3.47452 13.2001 4.8 13.2001ZM19.2 21.5998V15.5998H4.8V21.5998H19.2Z",
    fill: "currentColor"
  });
};

exports.GroupedView = GroupedView;